// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalInventoryLogs_root__3Bsov","log":"ModalInventoryLogs_log__3h-ed","date":"ModalInventoryLogs_date__1dNep","userName":"ModalInventoryLogs_userName__PNOl_"};